import React from "react";

//Style
import "./InsideViewSection.css";

const InsideViewSection = () => {
  return (
    <section className="inside-view-section">
      <div className="inside-view-subcontainer">
        <iframe
          title="vista-aerea"
          src="https://arqmotion-proyectos.com/MiradorApto/"
          frameborder="0"
          width={"100%"}
          height={"100%"}
        ></iframe>
      </div>
    </section>
  );
};

export default InsideViewSection;
